import { ApolloError } from '@apollo/client'
import { isString } from 'effect/Predicate'

/**
 * GraphQL エラーの種別は message でなく `extensions.code` で判定する (#9240)。
 * ErrorBoundary や props 経由では素の Error / unknown として届くため、ApolloError への絞り込みまで含める。
 */
export const hasGraphqlErrorCode = (error: unknown, codes: readonly string[]): boolean =>
  error instanceof ApolloError &&
  error.graphQLErrors.some(({ extensions }) => {
    const code = extensions?.code
    return isString(code) && codes.includes(code)
  })
